import React from 'react';
import { IonContent, IonHeader, IonIcon, IonPage, IonSpinner, IonTitle, IonToolbar, withIonLifeCycle } from '@ionic/react';
import './Settings.css';
import { withRouter } from 'react-router';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { deleteRequest, getJson, postJson } from '../fetchFunctions';
import { Storage } from '@capacitor/storage';
import { error, success } from '../components/ToastController';
import { alertDelete } from '../components/DialogController';
import QRCode from "react-qr-code";
import { cloudOfflineOutline } from 'ionicons/icons';

class Offline extends React.Component<any, any> {
	constructor(props: any) {
		super(props);

		this.state = {

		}
	}



	render() {
		return (
			<IonPage>
				<IonContent fullscreen>
					<div style={{display: "flex", justifyContent: "center", marginTop: "30vh", flexDirection: "column"}}>
						<div style={{display: "flex", justifyContent: "center"}}>
							<IonIcon icon={cloudOfflineOutline} style={{fontSize: "20vw", color: "#aaa"}} />
						</div>
						<h3 style={{color: "#555", marginTop: "30px", textAlign: "center"}}>
							Kunne ikke oprette forbindelse til serveren
						</h3>
					</div>
				</IonContent>
			</IonPage>
		)
	}
}

export default Offline;
